import { Box, IconButton as MuiIconButton, Paper, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { theme } from 'config/theme';
import { ReactComponent as ExpandDiagonalLineIcon } from 'assets/icons/ExpandDiagonalLineIcon.svg';
import { ReactComponent as CollapseDiagonalLineIcon } from 'assets/icons/CollapseDiagonalLineIcon.svg';
import { Dispatch, SetStateAction } from 'react';

type ToolbarProps = {
  isFullScreen: boolean;
  setFullScreen: Dispatch<SetStateAction<boolean>>;
};

function Toolbar({ isFullScreen, setFullScreen }: ToolbarProps) {
  return (
    <Box display="flex" alignItems="center" gap={1} ml={1} justifyContent="flex-end" p={2} mb={2}>
      <Tooltip
        placement="top"
        title={<TooltipMsg>{isFullScreen ? 'Collapse' : 'Expand'}</TooltipMsg>}
      >
        <IconButton
          onClick={() => setFullScreen((prevState) => !prevState)}
          sx={(theme) => ({
            border: `1px solid ${theme.palette.custom.divider}`,
            ...(isFullScreen && {
              backgroundColor: theme.palette.custom.tuna,
              color: theme.palette.custom.white,
              '&:hover': {
                color: theme.palette.custom.white,
                backgroundColor: theme.palette.custom.tuna,
              },
            }),
          })}
        >
          {isFullScreen ? (
            <CollapseDiagonalLineIcon width={18} />
          ) : (
            <ExpandDiagonalLineIcon width={18} />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
}

const IconButton = styled(MuiIconButton)(({ theme }) => ({
  borderRadius: 4,
  color: theme.palette.custom.tuna,
}));

const TooltipMsg = styled(Typography)(({ theme }) => ({
  color: theme.palette.custom.white,
  fontSize: 12,
  fontWeight: 600,
}));

export default Toolbar;
